import PropTypes from "prop-types";

import Icon from "components/ShellV2/Icon";

/* Settings/section card with an optional anchor id (`${id}-info`), icon title,
   optional subtitle and an optional action slot in the header. */
export default function SectionCard({ id, icon, title, sub, action, children, style }) {
  return (
    <div className="rec-card rec-card-pad" id={id ? `${id}-info` : undefined} style={style}>
      <div
        className={`flex justify-between flex-wrap gap-3 mb-4 ${
          sub ? "items-start" : "items-center"
        }`}
      >
        <div className="min-w-0">
          <h3 className="rec-section-title !mb-0">
            <Icon name={icon} />
            {title}
          </h3>
          {sub && <div className="text-[12.5px] text-ink-3 mt-1">{sub}</div>}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}

SectionCard.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  sub: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

SectionCard.defaultProps = {
  id: undefined,
  sub: null,
  action: null,
  children: null,
  style: undefined,
};
